import React from 'react';
import { WidgetPreviewHeaderStyle } from './style';

interface WidgetPreviewHeaderProps {
  mainTitle?: string;
  subTitle?: string;
}

const WidgetPreviewHeader = (props: WidgetPreviewHeaderProps) => {
  const { mainTitle, subTitle } = props;
  return (
    <WidgetPreviewHeaderStyle>
      {mainTitle ? (
        <div className="widget-main-title">{mainTitle}</div>
      ) : (
        <span className="require-info">위젯 타이틀을 설정해주세요.</span>
      )}
      <div className="widget-sub-title">
        {subTitle ? subTitle : <span className="require-info">위젯 서브 타이틀을 설정해주세요.</span>}
      </div>
    </WidgetPreviewHeaderStyle>
  );
};

export default WidgetPreviewHeader;
